import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PolarisVizProvider } from '@shopify/polaris-viz';
import { I18nContext, I18nManager } from '@shopify/react-i18n';
import '@shopify/polaris-viz/build/esm/styles.css';
import * as Sentry from '@sentry/react';

import App from './App';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}

// Shopify passes ?locale= in the iframe URL — e.g. "fr" or "fr-FR"
const params = new URLSearchParams(window.location.search);
const rawLocale = (params.get('locale') || 'en').slice(0, 2).toLowerCase();
const SUPPORTED_LOCALES = ['en', 'fr'];
const locale = SUPPORTED_LOCALES.includes(rawLocale) ? rawLocale : 'en';

// Set document language so Polaris web components (s-date-field, s-date-picker, etc.) use the correct locale
document.documentElement.lang = locale;

// Shopify React i18n manager — drives all useI18n() hooks in the app
const i18nManager = new I18nManager({
  locale,
  onError(error) {
    console.warn('[i18n]', error.message);
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <PolarisVizProvider>
        <I18nContext.Provider value={i18nManager}>
          <App />
        </I18nContext.Provider>
      </PolarisVizProvider>
    </BrowserRouter>
  </React.StrictMode>
);
